import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserAssets } from "../../services/transaction";

export const fetchUserAssets = createAsyncThunk(
  "userAssets/fetchUserAssets",
  async ({ assetTypeId, selectedAssetId = null }, { rejectWithValue }) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await getUserAssets(assetTypeId, accessToken);

      if (response.status === 200) {
        return { data: response.data.data, selectedAssetId };
      } else {
        throw new Error("Failed to fetch user assets");
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  data: [],
  selectedAsset: null,
  userAssetLoading: false,
  error: null,
};

const userAssetsSlice = createSlice({
  name: "userAssets",
  initialState,
  reducers: {
    setSelectedAsset: (state, action) => {
      state.selectedAsset = action.payload;
    },
    clearSelectedAsset: (state) => {
      state.selectedAsset = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAssets.pending, (state) => {
        state.userAssetLoading = true;
        state.error = null;
        state.data = [];
      })
      .addCase(fetchUserAssets.fulfilled, (state, action) => {
        state.userAssetLoading = false;
        state.data = action.payload.data || [];

        if (!state.selectedAsset && state.data.length > 0) {
          const selectedAssetId = action.payload.selectedAssetId;

          state.selectedAsset =
            state.data.find(asset => asset.id === selectedAssetId) || state.data[0];
        }
      })
      .addCase(fetchUserAssets.rejected, (state, action) => {
        state.userAssetLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedAsset, clearSelectedAsset } = userAssetsSlice.actions;
export default userAssetsSlice.reducer;
